import { render } from "./TariffsPage.vue?vue&type=template&id=14804bf7&ts=true"
import script from "./TariffsPage.vue?vue&type=script&lang=ts"
export * from "./TariffsPage.vue?vue&type=script&lang=ts"

import "./TariffsPage.vue?vue&type=style&index=0&id=14804bf7&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__